import { ArticleHeading2, Image, UIText1 } from '@cian/ui-kit';
import React from 'react';
import cn from 'classnames';

import { X2_IMAGE_SIZE_MEDIA_QUERY } from '../../types/mediaQueries';

import * as styles from './styles.css';

export interface IDealStepCardProps {
  heading: string;
  description: string | React.ReactNode;
  descriptionAppend?: React.ReactNode;
  imageX1Src: string;
  imageX2Src: string;
}

export const DealStepCard: React.FC<IDealStepCardProps> = props => {
  return (
    <div className={cn(styles['card'])}>
      <Image
        sources={[{ srcset: props.imageX2Src, media: X2_IMAGE_SIZE_MEDIA_QUERY }, { srcset: props.imageX2Src }]}
        src={props.imageX1Src}
        width={140}
        height={100}
        display="block"
        loading="lazy"
      />
      <div className={styles['text-content']}>
        <ArticleHeading2 as="h3">{props.heading}</ArticleHeading2>
        <UIText1>{props.description}</UIText1>
        {props.descriptionAppend}
      </div>
    </div>
  );
};
